import type { CodeBrand } from '@/config/codeBrand';

/** localStorage for Q7.3 — LBS: next purchase; Dice: what could improve. */
export const Q7_3_STORAGE_KEY = 'npdsurvey:q7_3';

export const Q7_3_OPTIONS_LBS = [
  'Choose this one again',
  'Go back to my usual choice',
  'Try another option',
  'Decide depending on the occasion',
] as const;

export const Q7_3_OPTIONS_DICE = [
  'Taste/flavour',
  'Overall experience',
  'Strength/intensity',
  'Appearance/pack',
  'Format',
  'Availability',
  'Nothing in particular',
] as const;

/** @deprecated Prefer brand-specific lists via `getQ7_3Options`. */
export const Q7_3_OPTIONS = Q7_3_OPTIONS_LBS;

export type Q7_3OptionLbs = (typeof Q7_3_OPTIONS_LBS)[number];
export type Q7_3OptionDice = (typeof Q7_3_OPTIONS_DICE)[number];
export type Q7_3Option = Q7_3OptionLbs | Q7_3OptionDice;

export type Q7_3Answers = {
  selected: Q7_3Option;
};

export function getQ7_3Options(brand: CodeBrand | null | undefined): readonly Q7_3Option[] {
  return brand === 'Dice' ? Q7_3_OPTIONS_DICE : Q7_3_OPTIONS_LBS;
}

function isQ7_3Option(v: unknown): v is Q7_3Option {
  return (
    typeof v === 'string' &&
    ((Q7_3_OPTIONS_LBS as readonly string[]).includes(v) ||
      (Q7_3_OPTIONS_DICE as readonly string[]).includes(v))
  );
}

export function readQ7_3Answers(): Q7_3Answers | null {
  try {
    const raw = localStorage.getItem(Q7_3_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const selected = (o as { selected?: unknown }).selected;
    if (isQ7_3Option(selected)) {
      return { selected };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeQ7_3Answers(data: Q7_3Answers): void {
  try {
    localStorage.setItem(Q7_3_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_3Answers(): void {
  try {
    localStorage.removeItem(Q7_3_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_3Complete(): boolean {
  return readQ7_3Answers() != null;
}
